import React from 'react';
import { Box, Switch, Typography } from '@mui/material';

interface Props {
  label: string;
  description?: string;
  value: boolean;
  onChange: (v: boolean) => void;
}

const ToggleField: React.FC<Props> = ({ label, description, value, onChange }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
    <Switch size="small" color="warning" checked={!!value} onChange={(e) => onChange(e.target.checked)} />
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#141417', fontFamily: 'Manrope, sans-serif' }}>{label}</Typography>
      {description && <Typography sx={{ fontSize: 11, color: '#6F6F6F' }}>{description}</Typography>}
    </Box>
  </Box>
);

export default ToggleField;
